import React, { useState } from 'react';

import { Button } from '@mui/material';

import ChatRuleImageSrcStep1 from '@common/assets/images/chat-rule-step-1.png';
import ChatRuleImageSrcStep2 from '@common/assets/images/chat-rule-step-2.png';
import ChatRuleImageSrcStep3 from '@common/assets/images/chat-rule-step-3.png';
import logoSrc from '@common/assets/study.ua.png';
import ChatRulesSteps from '@common/modules/Chat/Title/Rules/Steps';
import { useTranslationContext } from '@common/modules/Chat/context';

import ChatRuleMessage from './Message';
import ChatRulesModalStep from './Step';
import * as Styled from './styled';

interface PropsType {
	onClose: () => void;
}

const steps = [
	<ChatRulesModalStep
		title="Будьте ввічливими:"
		description="пишіть дружньо та з повагою. Не варто використовувати нецензурні вислови та зображення, посилання і інші матеріали, що не стосуються навчання."
		imgSrc={ChatRuleImageSrcStep1}
	/>,
	<ChatRulesModalStep
		title="Додавайте деталі:"
		description="якщо ви маєте питання стосовно конкретної вправи чи завдання вказуйте одразу, будь ласка, номер уроку, прикріплюйте знімок екрану та детально описуйте суть питання: це дозволить викладачу якнайшвидше допомогти вам без уточнень додаткової інформації."
		imgSrc={ChatRuleImageSrcStep2}
	/>,
	<ChatRulesModalStep
		title="Тільки про навчання:"
		description="у чаті обговорюємо тільки уроки та домашки. Якщо є ідеї чи запитання про навчання загалом звертайтесь до координатора програми або адміністрації Академії на вашій локації."
		descriptionLyceum="у чаті обговорюємо тільки уроки та домашки. Якщо є ідеї чи запитання про навчання загалом - звертайтесь до ментора класу або адміністрації Ліцею."
		imgSrc={ChatRuleImageSrcStep3}
	/>,
];

function ChatStudentModalContent({ onClose }: PropsType) {
	const { t } = useTranslationContext();
	const [activeStep, setActiveStep] = useState(0);

	const handleNextStep = () => {
		if (activeStep < steps.length - 1) {
			setActiveStep((prev) => prev + 1);
		}
	};

	const isFirstStep = activeStep === 0;

	const isLastStep = activeStep === steps.length - 1;

	return (
		<Styled.Wrap>
			<Styled.Logo src={logoSrc} alt="Logo" />
			{isFirstStep && (
				<>
					<Styled.Text variant="body2">
						Індивідуальний чат з викладачем - це ваш особистий простір для допомоги щодо навчальних
						питань: тут ви можете запитувати все, що стосується домашніх завдань або матеріалу
						уроку.
					</Styled.Text>
					<Styled.Text variant="subtitle1" color="#C41C1C">
						Щоб спілкування було ефективним і легким, ось кілька простих правил
					</Styled.Text>
				</>
			)}
			<ChatRulesSteps stepsLength={steps.length} activeStep={activeStep} />
			{steps[activeStep]}
			{isLastStep && <ChatRuleMessage />}
			{isLastStep ? (
				<Button variant="contained" onClick={onClose}>
					Ok
				</Button>
			) : (
				<Button variant="contained" onClick={handleNextStep}>
					{t('common.chat.continue')}
				</Button>
			)}
		</Styled.Wrap>
	);
}

export default ChatStudentModalContent;
